import React, { useState, useEffect } from 'react';
import { useLang } from '../contexts/LangContext';
import { useTheme } from '../contexts/ThemeContext';

// 09.08, audyt przed pierwszym publicznym wdrozeniem - poprzednia wersja (odziedziczona z ISO Forge)
// oferowala przelaczniki "analityczne"/"marketingowe" mimo ze Gap Assessment nie uzywa ANI JEDNEGO
// pliku cookie (potwierdzone grepem calego backendu - brak res.cookie/Set-Cookie, brak GA/GTM w
// frontendzie) - autoryzacja dziala przez token w localStorage, nie cookie. Falszywe kategorie do
// "wylaczenia" byly nieuczciwe (nic realnie nie kontrolowaly). Ten baner jest zwyklym, uczciwym
// powiadomieniem informacyjnym, nie bramka zgody na kategorie ktorych i tak nie ma.
// Kolorystyka (na prosbe Marcina "musi byc w tej samej kolorystyce co platforma"): baner renderuje
// sie jako rodzenstwo <Routes> w App.jsx, POZA drzewem .galp landing page'a - bez wlasnych tokenow
// dziedziczylby stary, generyczny motyw ISO Forge (niebieski akcent), nie Semafor. Tokeny
// zdublowane tu tak samo jak w PrivacyPage.jsx/TermsPage.jsx.
// 11.08: jezyk czytany ze wspoldzielonego LangContext zamiast jednorazowego odczytu localStorage
// przy montowaniu - naprawia przy okazji realny bug (baner nie reagowal na przelaczenie jezyka na
// stronie pod spodem po zamontowaniu). Ciemny motyw dodany do TOKENS - baner nie ma wlasnego
// przelacznika PL/EN/motywu (czysto informacyjny), tylko czyta reaktywnie kontekst.
const STORAGE_KEY = 'gap_cookie_notice_ack';
const TOKENS = `
.gcookie{
  --paper-raised:#F8F9F6; --ink:#1B2124; --ink-soft:#5C6569; --line-soft:#D9DCD5;
  --accent:#1E7A46; --accent-ink:#FFFFFF;
  --shadow:0 1px 2px rgba(20,30,25,.05), 0 8px 20px -12px rgba(20,30,25,.14);
}
[data-theme='dark'] .gcookie{
  --paper-raised:#1E2225; --ink:#E9EAE4; --ink-soft:#8B948F; --line-soft:#282C2E;
  --accent:#3CB878; --accent-ink:#0B1712;
  --shadow:0 1px 2px rgba(0,0,0,.4), 0 10px 24px -12px rgba(0,0,0,.55);
}
/* 10.08, audyt jakosciowy: pierwsza probka (sam ciasniejszy padding) wciaz zaslaniala glowne CTA
   w hero na telefonie - baner samego tekstu i tak zawijal sie na 3 linie. Druga proba: osobna,
   krotsza tresc TYLKO na mobile (gc-desc-full/gc-desc-short przelaczane przez CSS, nie JS - zero
   ryzyka niezgodnosci hydratacji react-snap), jedna linia zamiast trzech. */
.gcookie .gc-desc-short{ display:none; }
@media (max-width:640px){
  .gcookie{ padding:12px 14px !important; }
  .gcookie .gc-row{ flex-direction:column; align-items:stretch !important; gap:10px !important; }
  .gcookie .gc-title{ font-size:0.82rem !important; }
  .gcookie .gc-desc-full{ display:none; }
  .gcookie .gc-desc-short{ display:block; font-size:0.74rem !important; line-height:1.4 !important; }
  .gcookie .gc-btn{ width:100%; padding:9px 22px !important; }
}
`;

const STRINGS = {
  pl: {
    title: 'Ta strona nie używa plików cookies',
    desc: 'Logowanie działa przez ściśle niezbędny token przechowywany lokalnie w przeglądarce - zero śledzenia, zero analityki trzeciej strony.',
    descShort: 'Zero cookies - logowanie przez lokalny token.',
    privacyLink: 'Polityka prywatności',
    ack: 'Rozumiem',
  },
  en: {
    title: 'This site uses no cookies',
    desc: 'Login works via a strictly necessary token stored locally in your browser - no tracking, no third-party analytics.',
    descShort: 'No cookies - login via a local token.',
    privacyLink: 'Privacy Policy',
    ack: 'Got it',
  },
};

export default function CookieBanner() {
  // Pierwszy render musi byc identyczny na serwerze (react-snap) i kliencie, inaczej hydrateRoot
  // trafia na mismatch - stad zawsze null dopoki komponent nie jest faktycznie zamontowany.
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const { lang } = useLang();
  useTheme();

  useEffect(() => {
    if (typeof navigator !== 'undefined' && /ReactSnap/.test(navigator.userAgent)) return;
    setMounted(true);
    const acked = localStorage.getItem(STORAGE_KEY);
    if (!acked) setTimeout(() => setVisible(true), 800);
  }, []);

  const t = STRINGS[lang] || STRINGS.pl;
  const privacyHref = '/polityka-prywatnosci';

  const acknowledge = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!mounted) return null;

  return (
    <div className="gcookie" style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9990,
      background: 'var(--paper-raised)', borderTop: '1px solid var(--line-soft)',
      backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
      padding: '18px max(1.5rem, calc((100vw - 1100px)/2))',
      paddingBottom: 'calc(18px + env(safe-area-inset-bottom, 0px))',
      transform: visible ? 'translateY(0)' : 'translateY(100%)',
      transition: 'transform 0.4s cubic-bezier(0.16,1,0.3,1)',
      boxShadow: 'var(--shadow)',
      willChange: 'transform',
      pointerEvents: visible ? 'auto' : 'none',
      fontFamily: "'Inter','Inter Fallback','Segoe UI',sans-serif",
    }}>
      <style>{TOKENS}</style>
      <div className="gc-row" style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <span className="gc-title" style={{ fontSize: '0.92rem', fontWeight: 700, color: 'var(--ink)' }}>{t.title}</span>
          </div>
          <p className="gc-desc-full" style={{ fontSize: '0.8rem', color: 'var(--ink-soft)', lineHeight: 1.55, margin: 0 }}>
            {`${t.desc} `}
            <a href={privacyHref} style={{ color: 'var(--accent)', textDecoration: 'underline' }}>{t.privacyLink}</a>.
          </p>
          <p className="gc-desc-short" style={{ color: 'var(--ink-soft)', margin: 0 }}>
            {`${t.descShort} `}
            <a href={privacyHref} style={{ color: 'var(--accent)', textDecoration: 'underline' }}>{t.privacyLink}</a>.
          </p>
        </div>
        <button className="gc-btn" onClick={acknowledge} style={{
          background: 'var(--accent)', color: 'var(--accent-ink)', border: 'none', borderRadius: 8,
          padding: '9px 22px', fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer', flex: 'none',
        }}>{t.ack}</button>
      </div>
    </div>
  );
}
